import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Menu } from '@mui/material';
const HoverMenu = React.forwardRef(function HoverMenu(props, ref) {
    return (_jsx(Menu, { ...props, ref: ref, style: {
            pointerEvents: 'none',
            ...props.style,
        }, slotProps: {
            ...props.slotProps,
            paper: {
                style: { pointerEvents: 'auto' },
            },
        } }));
});
export default HoverMenu;
